import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=798c78e4&"
import script from "./MessageView.vue?vue&type=script&lang=ts&"
export * from "./MessageView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports